export default __webpack_public_path__ + "static/media/BrainBreak cards31.de81c465.png";